import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'unionId',
      type: 'input',
      label: '客户unionId',
      placeholder: '请输入客户unionId'
    }
  ]
}
